// Product Video Modal Handler
class ProductVideoModal {
  constructor() {
    this.modal = document.getElementById('xo-video-modal');
    this.player = document.getElementById('xo-video-player');
    this.closeBtn = document.querySelector('.xo-video-modal__close');
    this.overlay = document.querySelector('.xo-video-modal__overlay');
    this.thumbnails = document.querySelectorAll('.xo-product-video-thumbnail');
    
    this.init();
  }
  
  init() {
    if (!this.modal) return;
    
    // Thumbnail click events
    this.thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', () => {
        const videoId = thumbnail.dataset.videoId;
        const videoType = thumbnail.dataset.videoType;
        this.openModal(videoId, videoType);
      });
    });
    
    // Close button
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.closeModal());
    }
    
    // Overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closeModal());
    }
    
    // ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.closeModal();
      }
    });
  }
  
  openModal(videoId, videoType) {
    let embedUrl = '';
    
    if (videoType === 'youtube') {
      embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
    } else if (videoType === 'vimeo') {
      embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
    }
    
    const iframe = `<iframe src="${embedUrl}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    
    this.player.innerHTML = iframe;
    this.modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  
  closeModal() {
    this.player.innerHTML = '';
    this.modal.classList.remove('active');
    document.body.style.overflow = '';
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductVideoModal();
  });
} else {
  new ProductVideoModal();
}